import React, {Suspense, memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type QuickLinkBannerLinkProps = {
    href: string
    title: string
    children?: React.ReactNode
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

const QuickLinkBannerLink = memo((props: QuickLinkBannerLinkProps) => {
    const {mainTemplate, fallbackTemplate} = props.templating
    const TemplatedQuickLinkBannerLink = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)

    return (
        <Suspense>
            <TemplatedQuickLinkBannerLink {...props} />
        </Suspense>
    )
})

QuickLinkBannerLink.displayName = "QuickLinkBannerLink"

export default connect(QuickLinkBannerLink)
